import React, { Component } from 'react';
import { connect } from 'react-redux'
import { wishlistDefault, removeDefault, shopBagDefault } from '../MangoIcons'

class MobileView extends Component {

  getDataByView = (view, data) => {
    switch (view) {
      case "cart":
        return {
          name: data.RID_SKU_DESC,
          qty: data.RID_QTY,
          price: data.RID_PRICE,
          disc_price:data.RID_PRICE_DISC_AMT,
        }
      case "wish":
        return {
          name: data.SKU_DESC,
          price: data.LOT_SELLING_PRICE
        }
      case "order":
        return {
          name: data.SKU_DESC,
          qty: data.RPD_ORDER_QTY,
          price: data.RID_PRICE,
          orderNo: data.RPD_PRINCIPAL_ORDER_NO,
          orderDate: data.RIH_CART_CREATE_DATE,
          orderStatus: data.RPD_ITEM_STATUS_DESC
        }
      case "cancelOrder":
        return{
          name: data.SKU_DESC,
          qty: data.RPD_ORDER_QTY,
          size: data.SKU_SIZE,
          price: data.RID_PRICE,
          orderNo: data.RPD_PRINCIPAL_ORDER_NO,
          orderDate: data.RIH_CART_CREATE_DATE,
          orderStatus: data.RPD_ITEM_STATUS_DESC,
        }
      case "returnOrder":
        return{
          name: data.SKU_DESC,
          qty: data.RPD_ORDER_QTY,
          size:data.SKU_VARIANT2_VALUE_DESC,
          price: data.RID_PRICE,
          orderNo: data.RIH_PRINCIPAL_ORDER_NO,
          orderDate: data.RIH_CART_CREATE_DATE,
        }
    }
  }

  render() {
    const { data, view, functions, index, reasonList, presentURL } = this.props;
    const { removeBag, moveToWish, removeWish, moveToBag, updateCartItem, cancelOrder, handleSelectReason, handleCheckboxReason } = functions;
    
    return (
      <div>
        <div className="mobile-cart-content-new row">
          <div className="col-xs-3">
            <h6 className="td-color item-left">{this.getDataByView(view, data).name}</h6>
            {/* <h6 className="td-color item-right">Rs. {this.getDataByView(view, data).price}</h6>
            <h6 className="td-color item-right">Rs. {this.getDataByView(view, data).disc_price}</h6> */}
            </div></div>
          
       
        {
          (view == 'cart') ?
            <div className="mobile-cart-content-new row" style={{float:'left'}}>
              <div className="col-xs-3">
                <div className="qty-box item-right">
                  <div className="input-group">
                    <span className="input-group-prepend">
                      <button type="button" className="btn quantity-left-minus" onClick={(e) => updateCartItem(data, parseInt(data.RID_QTY) - 1 , e)}
                        data-type="minus" data-field="">
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </span>
                    <input type="text" name="quantity"
                      className="form-control input-number" defaultValue={this.getDataByView(view, data).qty} readOnly />
                    <span className="input-group-prepend">
                      <button className="btn quantity-right-plus" onClick={(e) => updateCartItem(data, parseInt(data.RID_QTY) + 1 , e)}
                        data-type="plus">
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </span>
                  </div>
                </div>
                <div className="item-right" style={{ display: "flex", flexDirection: "row" }}>
               
                  
                </div>
              </div>
            </div>
            :
            (view == 'wish') ?
              <div className="mobile-cart-content-new row" style={{float:'left'}}>
                <div className="col-xs-3">
                  <div className="item-left">
                    In Stock
                         </div>
                  <div className="item-right" style={{ display: "flex", flexDirection: "row" }}>
                    <a href="#" className="icon" title="Move to wishlist"
                      onClick={(event) => moveToBag(event, data)} style={{ height: 30, marginRight: 15 }}>
                      <img src={shopBagDefault} className="icon-hovers" width={30} height={30} />
                    </a>
                    <a href="#" className="icon" title="Remove item" style={{ height: 30 }}
                      onClick={(e) => removeWish(e, data)} >
                      <img src={removeDefault} className="icon-hovers" width={30} height={30} />
                    </a>
                  </div>
                </div>
              </div>
              :
              (view == 'order') ?
                <div className="mobile-cart-content-new row" style={{float:'left'}}>
                  <div className="col-xs-3">
                    <div className="item-left">
                      <h6 className="td-color">Qty : {this.getDataByView(view, data).qty}</h6>
                        <h6 className="td-color">Order# : {this.getDataByView(view, data).orderNo}</h6>
                        <h6 className="td-color">{this.getDataByView(view, data).orderDate}</h6>
                        <h6 className="td-color">Status : {this.getDataByView(view, data).orderStatus}</h6>
                        <h6 className="td-color item-left" style={{
    fontSize: 12,
    fontWeight: 500}}><b>Rs. {this.getDataByView(view, data).price}</b></h6>
     <h6><a href="#" className="icon" title="Remove item" style={{ height: 30 }}
                    onClick={(e) => removeBag(e, data)}
                  >
                    <img src={removeDefault} className="icon-hovers" width={35} height={35}/>
                  </a></h6>
                    </div>
                  </div>
                </div>
                :
                (view == 'cancelOrder') ?
                <div className="mobile-cart-content-new row" style={{float:'left'}}>
                  <div className="col-xs-3">
                    <div className="item-left">
                      <h6 className="td-color">Qty : {this.getDataByView(view, data).qty}</h6>
                      <h6 className="td-color">Size : {this.getDataByView(view, data).size}</h6>
                        <h6 className="td-color">Order# : {this.getDataByView(view, data).orderNo}</h6>
                        <h6 className="td-color">{this.getDataByView(view, data).orderDate}</h6>
                        <h6 className="td-color">Status : {this.getDataByView(view, data).orderStatus}</h6>
                        <h6 className="td-color">Eligible : <input className="checkbox_animated" disabled={data.cancel_eligible_flag === 'Y' ? false : true} value='' type="checkbox" onClick={(e) => cancelOrder(e,data)} /></h6>
                    </div>
                  </div>
                </div>
                 :
                 (view == 'returnOrder') ?
                 <div className="mobile-cart-content-new row" style={{float:'left'}}>
                   <div className="col-xs-3">
                     <div className="item-left">
                       <h6 className="td-color">Qty : {this.getDataByView(view, data).qty}</h6>
                       <h6 className="td-color">Size : {this.getDataByView(view, data).size}</h6>
                         <h6 className="td-color">Order# : {this.getDataByView(view, data).orderNo}</h6>
                         <h6 className="td-color">{this.getDataByView(view, data).orderDate}</h6>
                         <h6 className="td-color">Reason : 
                         <select className={"form-control"} ref={reasons => this['myReasonList'+index] = reasons} onChange={(e)=>handleSelectReason(e,data, index)} >
                          <option value="">Select Reason</option>
                          {reasonList && reasonList.map((reason, i) =>
                          <option key={i} value={reason.RSD_REASON_CD}>{reason.RSD_REASON_NAME}</option>
                              )}
                          </select>
                         </h6>
                         <h6 className="td-color">Checkbox : <input className="checkbox_animated" value='' type="checkbox" onClick={(e) => handleCheckboxReason(e,data,index)} /></h6>
                     </div>
                   </div>
                 </div>
                :
                ''
        }
        {(view === 'order') ? '' :  
        <div>
        <div className="mobile-cart-content-new row">
          <div className="col-xs-3" style={{    marginLeft: '50%'}}>
        <h6><a href="#" className="icon" title="Remove item" style={{ height: 30 }}
                    onClick={(e) => removeBag(e, data)}
                  >
                    <img src={removeDefault} className="icon-hovers" width={35} height={35}/>
                  </a></h6></div></div>
        <div className="mobile-cart-content-new row">
          <div className="col-xs-3">
        
            <h6 className="td-color item-left">Rs. {this.getDataByView(view, data).disc_price}</h6>
            {this.getDataByView(view, data).disc_price < this.getDataByView(view, data).price ?
            <h6 className="td-color item-left" style={{textDecoration: 'line-through',
    fontSize: 12,
    fontWeight: 500}}>Rs. { this.getDataByView(view, data).price}</h6> : '' }
            </div></div></div>
  }
      </div>
    )
  }
}

export default MobileView;